export const PICK_UP_ORDER_TABLE_NAME = "Pick-up";
export const DELIVERY_ORDER_TABLE_NAME = "Delivery";
